/* eslint-disable no-unused-expressions */
import withAdminDashboard from "../../../HOC/withAdminDashboard";
import withActivityLayout from "../../../../../components/Common/HOC/withActivityLayout";

const LOA = () => (
  withActivityLayout(() => null)({
    dataSheet: true,
    title: "Letter of Acceptance",
    extraCrumbs: [
      {
        url: "#",
        title: "Letter of Acceptance",
      },
    ]
  })
);

export default withAdminDashboard(LOA);
